import React, { useEffect, useState, useRef } from 'react';
import './Playoff.css';

function erf(x) {
  // Abramowitz & Stegun approximation (good enough)
  const a1 = 0.254829592, a2 = -0.284496736, a3 = 1.421413741, a4 = -1.453152027, a5 = 1.061405429, p = 0.3275911;
  const sign = (x < 0) ? -1 : 1;
  x = Math.abs(x);
  const t = 1.0 / (1.0 + p * x);
  const y = 1.0 - (((( (a5 * t + a4) * t ) + a3) * t + a2) * t + a1) * t * Math.exp(-x * x);
  return sign * y;
}
function normalCdf(z) {
  return 0.5 * (1 + erf(z / Math.sqrt(2)));
}
function customMultiply(a, b) {
  if (a > 0 && b > 0) {
    return a * b;
  } else if (a < 0 && b < 0) {
    return a * b * -1;
  } else {
    // one positive, one negative
    return (a + b) / 2;
  }
}


// Convert ratings -> win probability (home team's win prob)
function homeWinProb_fromRatings(homeRating, awayRating, homeFieldAdvantage = 2.5, sigma = 17.0) {
  const margin = homeRating - awayRating + homeFieldAdvantage; // positive => home favored
  const z = margin / sigma;
  return normalCdf(z); // returns 0..1
}

const listOfTeams = {
  "Georgia": 61,
  "Michigan": 130,
  "Ohio State": 194,
  "Alabama": 333,
  "LSU": 99,
  "Penn State": 213,
  "Florida State": 52,
  "USC": 30,
  "Washington": 264,
  "Texas": 251,
  "Tennessee": 2633,
  "Clemson": 228,
  "Notre Dame": 87,
  "Oregon": 2483,
  "Utah": 254,
  "Kansas State": 2306,
  "Oklahoma": 201,
  "North Carolina": 153,
  "Ole Miss": 145,
  "Wisconsin": 275,
  "TCU": 2628,
  "Texas A&M": 245,
  "Missouri": 142,
  "Iowa": 2294,
  "UCLA": 26,
  "Oklahoma State": 197,
  "Tulane": 2655,
  "Kentucky": 96,
  "South Carolina": 2579,
  "Arkansas": 8,
  "Auburn": 2,
  "Mississippi State": 344,
  "Minnesota": 135,
  "Texas Tech": 2641,
  "Purdue": 2509,
  "Maryland": 120,
  "Illinois": 356,
  "Baylor": 239,
  "Louisville": 97,
  "Nebraska": 158,
  "Iowa State": 66,
  "Miami (FL)": 2390,
  "Boise State": 68,
  "Oregon State": 204,
  "Pittsburgh": 221,
  "BYU": 252,
  "Duke": 150,
  "Wake Forest": 154,
  "UCF": 2116,
    "Liberty": 2335,
    "UTSA": 2636,
    "Miami": 2390,
    "Kansas": 2305,
    "Arizona State": 9,
    "Toledo": 2649,
    "UNLV": 2439,
    "SMU": 2567,
    "Arizona": 12,
    "Colorado": 38,
    "James Madison": 256,
    "Indiana": 84,
    "Army": 349,
    "Washington State": 265,
    "Memphis": 235,
    "Syracuse":183,
    "Texas State":326,
    "South Florida": 58,
    "Georgia Tech": 59,
    "Florida": 57,
    "Cincinnati": 2132,
    "Rutgers": 164,
    "Boston College": 103,
    "Virginia Tech": 259,
    "Fresno State": 278,
    "Jacksonville State": 55,
    "Houston": 248,
    "Ohio": 195,
    "North Texas": 249,
    "NC State": 152,
    "California": 25,
    "Florida Atlantic": 2226,
    "Old Dominion": 295,
    "Virginia": 258,
    "UConn": 41,
    "Vanderbilt": 238,
    "App State": 2026,
    "Michigan State": 127,
    "Louisiana Tech": 2348,
    "East Carolina": 151,
    "Temple": 218,
    "Colorado State": 36,
    "Miami (OH)": 193,
    "Louisiana": 309,
    "New Mexico State": 166,
    "Stanford": 24,
    "Central Michigan": 2117,
    "Rice": 242,
    "Coastal Carolina": 324,
    "Georgia Southern": 290,
    "Akron": 2006,
    "New Mexico": 167,
    "Western Michigan": 2711,
    "San Diego State": 21,
    "Nevada": 2440,
    "Marshall": 276,
    "Hawai'i": 62,
    "Air Force": 2005,
    "Sam Houston": 2534,
    "Eastern Michigan": 2199,
    "Georgia State": 2247,
    "UAB": 5,
    "Tulsa": 202,
    "Southern Miss": 2572,
    "Kennesaw State": 338,
    "Charlotte": 2429,
    "Ball State": 2050,
    "Delaware": 48,
    "Kent State": 2309,
    "Missouri State": 2623,
    "UL Monroe": 2433,
    "Middle Tennessee": 2393,
    "Massachusetts": 113,
    "San Jos\u00e9 State": 23,
    "West Virginia": 277,
    "Wyoming": 2751,
    "Arkansas State": 2032,
    "UTEP": 2638,
    "Utah State": 328,
    "Florida International": 2229,
    "Troy": 2653,
    "South Alabama": 6,
    "Navy": 2426,
    "Buffalo": 2084,
    "Western Kentucky": 98,
    "Northwestern": 77,
    "Northern Illinois": 2459,
    "Bowling Green": 189,

};

const More = ({ onPageChange, league }) => {

    const [teams, setTeams] = useState([]);
    const [games, setGames] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [loading, setLoading] = useState(false);
    const [UPSET_INDEX, setUPSET_INDEX] = useState(1000);
    const [week, setWeek] = useState(15);


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            try {console.log("here");
                // Fetch ratings data
                const ratingsData = await fetchWithCache("ratingsResponse", "http://localhost:3001/api/ratings/fpi");
      const spData = await fetchWithCache("spResponse", "http://localhost:3001/api/ratings/sp");
      const talentData = await fetchWithCache("talentResponse", "http://localhost:3001/api/talent");
                const gameData = await fetchWithCache("gameResponse", "http://localhost:3001/api/games");

                console.log(gameData);


                /*const ratingsResponse = await fetch('http://localhost:3001/api/ratings/fpi2');
                const spResponse = await fetch('http://localhost:3001/api/ratings/sp2');
                const talentResponse = await fetch('http://localhost:3001/api/talent2');
                const gameResponse = await fetch('http://localhost:3001/api/games2');
       
                const ratingsData = await ratingsResponse.json();
                const spData = await spResponse.json();
                const talentData = await talentResponse.json();
                const gameData = await gameResponse.json(); */
                
                // Combine data
                const combinedData = {};
                
                const gameScores = [];
                /*
                combinedData["SEC"] = {
                            team: "SEC",
                            conference: "Conference",
                            rating: 0,
                            value: 10000,
                            talent: 0,
                            avg: 0,
                            wins: 0,
                            gp: 0,
                            BestWin: "",
                            BestWinVal: 0,
                            WorstLoss: "",
                            WorstLossVal: 1000,
                            Losses: "",
                            LossesTeams: [],
                            count:0
                        };
                        combinedData["Big Ten"] = {
                           team: "Big Ten",
                            conference: "Conference",
                            rating: 0,
                            value: 10000,
                            talent: 0,
                            avg: 0,
                            wins: 0,
                            gp: 0,
                            BestWin: "",
                            BestWinVal: 0,
                            WorstLoss: "",
                            WorstLossVal: 1000,
                            Losses: "",
                            LossesTeams: [],
                            count:0
                        };
                        combinedData["Big 12"] = {
                            team: "Big 12",
                            conference: "Conference",
                            rating: 0,
                            value: 10000,
                            talent: 0,
                            avg: 0,
                            wins: 0,
                            gp: 0,
                            BestWin: "",
                            BestWinVal: 0,
                            WorstLoss: "",
                            WorstLossVal: 1000,
                            Losses: "",
                            LossesTeams: [],
                            count:0
                        };
                        combinedData["ACC"] = {
                            team: "ACC",
                            conference: "Conference",
                            rating: 0,
                            value: 10000,
                            talent: 0,
                            avg: 0,
                            wins: 0,
                            gp: 0,
                            BestWin: "",
                            BestWinVal: 0,
                            WorstLoss: "",
                            WorstLossVal: 1000,
                            Losses: "",
                            LossesTeams: [],
                            count:0
                        };
                        combinedData["American Athletic"] = {
                            team: "American Athletic",
                            conference: "Conference",
                            rating: 0,
                            value: 10000,
                            talent: 0,
                            avg: 0,
                            wins: 0,
                            gp: 0,
                            BestWin: "",
                            BestWinVal: 0,
                            WorstLoss: "",
                            WorstLossVal: 1000,
                            Losses: "",
                            LossesTeams: [],
                            count:0
                            }
                         combinedData["Sun Belt"] = {
                            team: "Sun Belt",
                            conference: "Conference",
                            rating: 0,
                            value: 10000,
                            talent: 0,
                            avg: 0,
                            wins: 0,
                            gp: 0,
                            BestWin: "",
                            BestWinVal: 0,
                            WorstLoss: "",
                            WorstLossVal: 1000,
                            Losses: "",
                            LossesTeams: [],
                            count:0
                        };
                        combinedData["Mountain West"] = {
                            team: "Mountain West",
                            conference: "Conference",
                            rating: 0,
                            value: 10000,
                            talent: 0,
                            avg: 0,
                            wins: 0,
                            gp: 0,
                            BestWin: "",
                            BestWinVal: 0,
                            WorstLoss: "",
                            WorstLossVal: 1000,
                            Losses: "",
                            LossesTeams: [],
                            count:0
                        };
                        combinedData["Mid-American"] = {
                            team: "Mid-American",
                            conference: "Conference",
                            rating: 0,
                            value: 10000,
                            talent: 0,
                            avg: 0,
                            wins: 0,
                            gp: 0,
                            BestWin: "",
                            BestWinVal: 0,
                            WorstLoss: "",
                            WorstLossVal: 1000,
                            Losses: "",
                            LossesTeams: [],
                            count:0
                        };
                        combinedData["Conference USA"] = {
                            team: "Conference USA",
                            conference: "Conference",
                            rating: 0,
                            value: 10000,
                            talent: 0,
                            avg: 0,
                            wins: 0,
                            gp: 0,
                            BestWin: "",
                            BestWinVal: 0,
                            WorstLoss: "",
                            WorstLossVal: 1000,
                            Losses: "",
                            LossesTeams: [],
                            count:0
                        };*/

                // Process ratings data
                ratingsData.forEach(team => {
                    if (!combinedData[team.team]) {
                        
                        combinedData[team.team] = {
                            team: team.team,
                            conference: team.conference,
                            rating: (team.fpi + 0),
                            value: 0,
                            talent: 0,
                            avg: (team.fpi),
                            wins: 0,
                            gp: 0,
                            BestWin: "",
                            BestWinVal: 0,
                            WorstLoss: "",
                            WorstLossVal: 1000,
                            Losses: "",
                            LossesTeams: []
                        };

                        /*if(team.conference == "Big Ten" || team.conference == "SEC" || team.conference == "ACC"){
                            combinedData[team.team].value += 85;
                        }
                        if (team.conference == "Big Ten" || team.conference == "ACC") {
                            combinedData[team.team].value += 10;
                        }
                        if (team.conference == "Big 12") {
                            combinedData[team.team].value += 60;
                        }
                        if (team.team == "Notre Dame") {
                            combinedData[team.team].value += 60;
                        }
                        if (team.team == "USC") {
                            combinedData[team.team].avg -= 3;
                        }
                        if (team.team == "Nebraska") {
                            combinedData[team.team].avg -= 3;
                        }
                        if (team.team == "Michigan") {
                            combinedData[team.team].value -= 5;
                        }
                        if (team.team == "Tennessee") {
                            combinedData[team.team].value += 25;
                        }
                        if (team.team == "Texas") {
                            combinedData[team.team].avg -= 4;
                        }
                         if (team.team == "Ole Miss") {
                            combinedData[team.team].avg += 5;
                        }
                        if (team.team == "Ole Miss") {
                            combinedData[team.team].value += 90;
                        }
                        if (team.team == "Missouri") {
                            combinedData[team.team].value -= 5;
                        }
                        if (team.team == "Oklahoma") {
                            combinedData[team.team].value -= 5;
                        }
                        if (team.team == "Alabama") {
                            combinedData[team.team].value -= 5;
                        }*/
                        if (team.team == "Ole Miss") {
                            //combinedData[team.team].value -= 5;
                        }

                        

                         combinedData[team.team].avg = combinedData[team.team].avg / 5 * 0;
                         

                         const bonusAvgs = {
                             "Ohio State": 29.9993293996248,
                             "Alabama": 26.9338417364709,
                             "Oregon": 26.7990933911263,
                             "Notre Dame": 25.9461024662782,
                             "Georgia": 24.913285581824,
                             "Miami": 23.748941118515,
                             "Indiana": 23.5884545173924,
                             "Texas": 22.7053971733917,
                             "Texas A&M": 22.4764763967776,
                             "Texas Tech": 22.3831579863048,
                             "Oklahoma": 21.2225559747679,
                             "USC": 19.5785989889099,
                             "Tennessee": 19.4199723738865,
                             "Missouri": 19.3380421164735,
                             "Vanderbilt": 19.3180255326052,
                             "Ole Miss": 19.2578691342951,
                             "Utah": 18.3022798781154,
                             "LSU": 17.4038011383336,
                             "Auburn": 16.1032542884121,
                             "Florida State": 15.9945238163756,
                             "Michigan": 15.3175436644306,
                             "South Florida": 13.9775028573361,
                             "Louisville": 12.9720478554412,
                             "Penn State": 12.5398935162334,
                             "Washington": 12.4237406644199,
                             "Arkansas": 12.1149355599736,
                             "BYU": 12.0760757301316,
                             "South Carolina": 11.7777778109854,
                             "Arizona State": 11.7398928805047,
                             "Iowa State": 11.4228643228085,
                             "Iowa": 11.2103844696896,
                             "Nebraska": 11.1601445428258,
                             "Mississippi State": 11.1420753285605,
                             "Illinois": 11.1031371818177,
                             "Florida": 11.0901035771351,
                             "Georgia Tech": 10.1877153604032,
                             "TCU": 9.91364172182396,
                             "Cincinnati": 8.74344223111835,
                             "Pittsburgh": 8.51891283224227,
                             "Arizona": 8.434308417784,
                             "Clemson": 7.76374902253764,
                             "Boise State": 7.56033204041623,
                             "Virginia": 7.36541786156605,
                             "Colorado": 7.18727239480472,
                             "Houston": 6.70255406267089,
                             "Kansas": 6.22905522354666,
                             "Memphis": 6.18939771649659,
                             "Kansas State": 6.16377009294858,
                             "Kentucky": 5.94225578139429,
                             "Baylor": 5.87425829865938,
                             "Rutgers": 5.40516035344106,
                             "SMU": 5.17568038330382,
                             "Duke": 5.07145245882605,
                             "Old Dominion": 4.25208576267788,
                             "NC State": 4.14356213629968,
                             "Minnesota": 4.14223620858764,
                             "Northwestern": 4.12993791646794,
                             "James Madison": 4.12236073252148,
                             "North Texas": 3.42037169036992,
                             "Maryland": 3.15122202855518,
                             "Michigan State": 1.63281418429744,
                             "Tulane": 0.89852936296835,
                             "Purdue": 0.174628599095909,
                             "FCS": 0,
                             "Wake Forest": -0.648862049907138,
                             "UCLA": -0.69622288663165,
                             "Wisconsin": -1.10218520859235,
                             "UCF": -1.12117943790624,
                             "Toledo": -1.21042901551507,
                             "Louisiana Tech": -1.72823746595451,
                             "Virginia Tech": -1.77519429718538,
                             "San Diego State": -2.83865779939055,
                             "Navy": -3.44859417217763,
                             "Washington State": -3.68538321611909,
                             "Texas State": -3.70435626058932,
                             "East Carolina": -3.79899990491744,
                             "California": -4.21786913133985,
                             "UNLV": -4.26369572687741,
                             "Utah State": -4.34972139779871,
                             "Southern Miss": -4.37961939912284,
                             "UTSA": -4.47264048906997,
                             "Stanford": -4.55527829565909,
                             "San Jos\u00e9 State": -4.80629673235577,
                             "Syracuse": -4.87500783094797,
                             "Ohio": -5.10762504172737,
                             "New Mexico": -5.26332809555535,
                             "Troy": -5.35189722951413,
                             "Western Kentucky": -6.18733305508102,
                             "South Alabama": -6.88674720579707,
                             "Army": -7.06744424908202,
                             "App State": -7.15210886856782,
                             "Kennesaw State": -7.61439519813948,
                             "Air Force": -7.85411750238912,
                             "West Virginia": -7.9778992994523,
                             "Wyoming": -8.31775210278038,
                             "Temple": -8.73756288801977,
                             "Boston College": -8.75055752917733,
                             "Marshall": -8.91970192206402,
                             "Hawai'i": -8.99762902529442,
                             "UConn": -9.36423786170384,
                             "Miami (OH)": -9.50749786139145,
                             "Oregon State": -9.55982120964599,
                             "Colorado State": -9.72338584605586,
                             "Georgia Southern": -9.72885926257366,
                             "Fresno State": -10.2688242910373,
                             "Delaware": -10.2944520498398,
                             "North Carolina": -10.4076399996451,
                             "Western Michigan": -10.6585274002273,
                             "Liberty": -11.3964723736994,
                             "Arkansas State": -11.7939875144634,
                             "Buffalo": -11.855015432812,
                             "Louisiana": -12.5408188075686,
                             "UL Monroe": -13.2285220864861,
                             "Florida International": -13.8599454816808,
                             "Missouri State": -14.138806565859,
                             "Jacksonville State": -14.5741528052624,
                             "Bowling Green": -15.0250365625031,
                             "Georgia State": -15.4490660592853,
                             "Coastal Carolina": -15.5477727972693,
                             "Florida Atlantic": -15.7250222791361,
                             "Northern Illinois": -16.7756800811473,
                             "UTEP": -16.9095258698716,
                             "Middle Tennessee": -16.9946114021935,
                             "New Mexico State": -17.1852582773136,
                             "Nevada": -17.3206679617017,
                             "Central Michigan": -17.4106664469157,
                             "UAB": -17.9742879885884,
                             "Tulsa": -18.7511044200908,
                             "Eastern Michigan": -19.2129432158711,
                             "Oklahoma State": -19.9680146648531,
                             "Ball State": -21.1931258791422,
                             "Rice": -21.5693131879648,
                             "Akron": -22.1257237524926,
                             "Sam Houston": -22.7037159020879,
                             "Charlotte": -23.9080849367607,
                             "Kent State": -25.4611075607505,
                             "Massachusetts": -30.8875834048512,


                         };

                         const bonus = bonusAvgs[team.team];
                         if (bonus) {
                             combinedData[team.team].avg += bonus / 1;
                             }
                             else{
                                 console.log(team.team);
                             }

                             if(team.team == "Oklahoma"){
                                 //combinedData[team.team].avg += 1;
                             }
                             if (team.team == "Ole Miss") {
                           // combinedData[team.team].avg -= 9;
                        }
                        
                    }
                });

                spData.forEach(team => {
                    if (combinedData[team.team]) {
                        //combinedData[team.team].avg += team.rating / 5;
                    }
                });

                talentData.forEach(team => {
                     if (combinedData[team.team]) {
                       // combinedData[team.team].avg += (team.talent - 500) / 100;
                    }
                });


                // Convert combinedData to an array and sort by avg
                const sortedData = Object.keys(combinedData).map(key => ({
                    team: key,
                    ...combinedData[key]
                })).sort((a, b) => b.avg - a.avg); // Sort in descending order
                
                console.log(sortedData);
                
                //const UPSET_INDEX = 3;
                const Windex =20;
               // console.log(UPSET_INDEX);
                // Simulate the season



                gameData.forEach(game => {
                    if(game.week < week){

                        if (game.homeTeam && game.awayTeam) {
                            const homeTeam = combinedData[game.homeTeam];
                            const awayTeam = combinedData[game.awayTeam];
                        
                            var HomeWinner = true;
                            var HomeWinOdds = 0.5;
                            var AwayWinOdds = 0.5;
                            var odds = false;

                            if (game.completed && game.week != week-1) {
                                if (game.homePoints > game.awayPoints) {
                                    HomeWinner = true;
                                    
                                    
                                    if (homeTeam && awayTeam) {
                                       
                                        /*homeTeam.avg += awayTeam.avg / 1000;
                                        awayTeam.avg -= (100 - homeTeam.avg) / 1000;*/
                                    }
                                }
                                else if (game.homePoints == game.awayPoints) {
                                   // console.log(game);
                                }
                                else
                                    {
                                        HomeWinner = false;
                                        if (homeTeam && awayTeam) {
                                            /* homeTeam.avg -= (100 - awayTeam.avg) / 1000;
                                             awayTeam.avg += homeTeam.avg / 1000;*/
                                        }
                                    }
                            }
                            else{
                                if (homeTeam && awayTeam) {
                                    const randomness = Math.random();
                                    const UI = 0;
                                    var b12 = homeTeam.conference == "Big 12" || awayTeam.conference == "Big 12";                                    
                                    var sec = homeTeam.conference == "SEC" || awayTeam.conference == "SEC";                                    
                                    var b10 = homeTeam.conference == "Big Ten" || awayTeam.conference == "Big Ten";                                    
                                    var acc = homeTeam.conference == "ACC" || awayTeam.conference == "ACC";                                    
                                    var HomeField = 2.5;
                                    if(game.neutralSite){
                                        HomeField = 0;
                                    }
                                    //if (b12 || acc){ HomeField = 5};
                                    //HomeWinner = homeTeam.avg + UI*Math.random() + 5 > awayTeam.avg + UI * Math.random();
                                    HomeWinner = homeTeam.avg + HomeField + UI * Math.random() > awayTeam.avg + UI * Math.random();

                                    const power = 5; // Try 2, 3, or even higher
                                    //HomeWinOdds = Math.pow(homeTeam.avg+31, power) / (Math.pow(homeTeam.avg+31, power) + Math.pow(awayTeam.avg+30, power));
                                    //AwayWinOdds = Math.pow(awayTeam.avg+30, power) / (Math.pow(homeTeam.avg+31, power) + Math.pow(awayTeam.avg+30, power));

                                    //const home = 25, away = 30, hfa = 2.5, sigma = 17.0;
                                    HomeWinOdds = homeWinProb_fromRatings(homeTeam.avg, awayTeam.avg, 2.5, 16);
                                    AwayWinOdds = 1 - HomeWinOdds;


                                    if(game.week == week-1){
                                        const hq = homeTeam.value + homeTeam.avg;
                                        const aq = awayTeam.value + awayTeam.avg;
                                    gameScores.push({
                                      id: game.id,
                                      home: homeTeam.team,
                                      away: awayTeam.team,
                                      hc: (HomeWinOdds*100).toFixed(0),
                                      ac: (AwayWinOdds*100).toFixed(0),
                                      hq:hq,
                                      aq:aq,
                                      quality: customMultiply(hq, aq) - Math.abs(((hq+2.5) - aq)*10)

                                    });
                                    return;
                                    }
                                }
                                else if(awayTeam){
                                    HomeWinner = false;
                                }
                            }
                          
                            
                       
                            if(odds){
                                if (homeTeam && awayTeam) {
                                homeTeam.gp += 1;
                                awayTeam.gp += 1;

                                homeTeam.wins += HomeWinOdds;
                                awayTeam.wins += AwayWinOdds;

                                homeTeam.value += HomeWinOdds * (Windex * (1+awayTeam.avg / 30) + game.week / 20);
                                awayTeam.value += AwayWinOdds * (Windex * (1+homeTeam.avg / 30) + game.week / 20);
                                
                                awayTeam.value -= HomeWinOdds * (Windex * (1-homeTeam.avg / 30) + game.week / 20);
                                homeTeam.value -= AwayWinOdds * (Windex * (1-awayTeam.avg / 30) + game.week / 20);
                                }
                                else if (homeTeam) {
                                    homeTeam.gp += 1;
                                    homeTeam.wins += 1;
                                    homeTeam.value += Windex;
                                    if (homeTeam.BestWin == "") {
                                        homeTeam.BestWin = "FCS";
                                    }
                                }
                                else if (awayTeam) {
                                    awayTeam.gp += 1;
                                    awayTeam.wins += 1;
                                    awayTeam.value += Windex;
                                    if (awayTeam.BestWin == "") {
                                        awayTeam.BestWin = "FCS";
                                    }
                                }

                            }else{

                            if (homeTeam && awayTeam) {

                                if (awayTeam.value > homeTeam.BestWinVal && HomeWinner) {
                                    homeTeam.BestWin = awayTeam.team;
                                    homeTeam.BestWinVal = awayTeam.value;
                                }

                                if (homeTeam.value > awayTeam.BestWinVal && !HomeWinner) {
                                    awayTeam.BestWin = homeTeam.team;
                                    awayTeam.BestWinVal = homeTeam.value;
                                }
                                
                                //awayTeam.BestWin = homeTeam.team;
                                homeTeam.gp += 1;
                                awayTeam.gp += 1;

                                var hVal = 2;
                                if (homeTeam.avg >= 80) {
                                    hVal += 3;
                                }
                                if (homeTeam.avg >= 70) {
                                    hVal += 2;
                                }
                                if (homeTeam.avg >= 60) {
                                    hVal += 2;
                                }

                                var aVal = 2;
                                if (awayTeam.avg >= 80) {
                                    aVal += 3;
                                }
                                if (awayTeam.avg >= 70) {
                                    aVal += 2;
                                }
                                if (awayTeam.avg >= 60) {
                                    aVal += 2;
                                }

                                var m = 3;
                                if (HomeWinner) {
                                    homeTeam.wins += 1;

                                    homeTeam.value += Windex + m*(15 + awayTeam.avg / 2) + game.week / 1;
                                    awayTeam.value -= Windex + m*(15 - homeTeam.avg / 2) + game.week / 1;
                                    awayTeam.LossesTeams = awayTeam.LossesTeams || [];
                                    awayTeam.LossesTeams.push(homeTeam.team);
                                    //homeTeam.avg += (30 - homeTeam.avg) / 30;
                                    //awayTeam.avg -= (30 - awayTeam.avg) / 30;
                                } else {

                                    awayTeam.wins += 1;

                                    homeTeam.value -= Windex + m*(15 - homeTeam.avg / 2) + game.week / 1;
                                    awayTeam.value += Windex + m*(15 + homeTeam.avg / 2) + game.week / 1;

                                    //awayTeam.avg += (30 - awayTeam.avg) / 30;
                                   // homeTeam.avg -= (30 - homeTeam.avg) / 30;

                                    homeTeam.LossesTeams = homeTeam.LossesTeams || [];
                                    homeTeam.LossesTeams.push(awayTeam.team);
                                }
                            }
                            else if (homeTeam) {
                                homeTeam.gp += 1;
                                homeTeam.wins += 1;
                                homeTeam.value += Windex;
                                if (homeTeam.BestWin == "") {
                                    homeTeam.BestWin = "FCS";
                                }
                            }
                            else if (awayTeam) {
                                awayTeam.gp += 1;
                                awayTeam.wins += 1;
                                awayTeam.value += Windex;
                                if (awayTeam.BestWin == "") {
                                    awayTeam.BestWin = "FCS";
                                }
                            }
                                                        }


                        }
                        }
                });

                const updatedSortedData1 = Object.keys(combinedData).map(key => ({
                    team: key,
                    ...combinedData[key]
                })).sort((a, b) => (1 * b.wins) - (1 * a.wins));

                const firstTeamsByConference = {};
                const secondTeamsByConference = {};
                var num = 4;
                

                Object.values(updatedSortedData1).forEach((team, index) => {
                    const conference = team.conference;

                    if(false){
                  
                     // Make sure this conference entry exists
                     console.log(conference);
                       const confRow = Object.values(updatedSortedData1).find(t => t.team === conference);

                      if (confRow) {
                        confRow.avg += (team.avg);
                        confRow.gp = 12;
                        confRow.wins += team.wins;
                        //confRow.value += team.value;
                      confRow.count += 1;
                      }

      


                        /*if(team.team == "Indiana"){
                        team.value += 50 * (team.gp / 24 + 0.5);
                        }*/
                        if(team.team == "Utah"){
                        team.value += 50 * (team.gp / 24 + 0.5);
                        }
                        if(team.team == "Tennessee"){
                        team.value += 50 * (team.gp / 24 + 0.5);
                        }
                        if(team.team == "Texas A&M"){
                         team.value -= 50 * (team.gp / 24 + 0.5);
                        }
                        
                        if(team.team == "BYU"){
                         team.value -= 0 * (team.gp / 24 + 0.5);
                        }
                        if(team.team == "Iowa State"){
                         team.value += 50 * (team.gp / 24 + 0.5);
                        }
                        if(team.team == "Washington"){
                         team.value += 50 * (team.gp / 24 + 0.5);
                        }
                        if(team.team == "Arizona State"){
                         team.value -= 2 * (team.gp / 24 + 0.5);
                        }
                        if(team.team == "Iowa"){
                         team.value -= 20 * (team.gp / 24 + 0.5);
                        }
                        if(team.team == "Illinois"){
                         team.value -= 20 * (team.gp / 24 + 0.5);
                        }
                        if(team.team == "Notre Dame"){
                         team.value -= 45 * (team.gp / 24 + 0.5);
                        }
                        if(team.team == "Memphis"){
                         team.value -= 25 * (team.gp / 24 + 0.5);
                        }
                        
                    

                    
                    }
                    if (week > 16 && true) {
                        // SEC
                        if (team.team == "Alabama") {
                            //team.value += 300 - 150 * (team.gp - team.wins > 0 ? 1 : 0);
                            team.value += 250;
                            team.gp++;
                            team.wins++;
                        }
                        if (team.team == "Georgia") {
                            team.gp++;
                            team.value -= 0;
                            team.LossesTeams.push("Alabama");
                        }

                        // Big Ten
                        if (team.team == "Ohio State") {
//team.value += 300 - 150 * (team.gp - team.wins > 0 ? 1 : 0);
                            team.value += 250;                            team.gp++;
                            team.wins++;
                        }
                        if (team.team == "Indiana") {
                            team.gp++;
                            team.value -= 0;
                            team.LossesTeams.push("Ohio State");
                        }

                        // ACC
                        if (team.team == "Louisville") {
//team.value += 300 - 150 * (team.gp - team.wins > 0 ? 1 : 0);
                            team.value += 250;                            team.gp++;
                            team.wins++;
                        }
                        if (team.team == "Georgia Tech") {
                            team.gp++;
                            team.value -= 0;
                            team.LossesTeams.push("Louisville");
                        }

                        // Big 12
                        if (team.team == "Texas Tech") {
//team.value += 300 - 150 * (team.gp - team.wins > 0 ? 1 : 0);
                            team.value += 250;                            team.gp++;
                            team.wins++;
                        }
                        if (team.team == "BYU") {
                            team.gp++;
                            team.value += 0;
                            team.LossesTeams.push("Texas Tech");
                        }

                        // MW
                        /*if (team.team == "Boise State") {
                            team.value += 20;
                            team.gp++;
                            team.wins++;
                        }
                        if (team.team == "UNLV") {
                            team.gp++;
                            team.value -= 20;
                        }

                        // AAC
                        if (team.team == "Tulane") {
                            team.value += 20;
                            team.gp++;
                            team.wins++;
                        }
                        if (team.team == "Memphis") {
                            team.gp++;
                            team.value -= 20;
                        }*/

                        
                        if (conference != "FBS Independents" && conference != "Pac-12" && !(conference == "Big 12" || conference == "ACC" || conference == "SEC" || conference == "Big Ten") && true){
                            team.value -= 50;
                            if (!firstTeamsByConference[conference] && firstTeamsByConference[conference] != 0) {
                                team.gp++;
                                firstTeamsByConference[conference] = index;
                            } else if (!secondTeamsByConference[conference]) {
                                team.gp++;
                                //console.log(team);
                                //console.log(team.avg - updatedSortedData1[firstTeamsByConference[conference]].avg);
                                if (team.avg > updatedSortedData1[firstTeamsByConference[conference]].avg) {
                                    team.wins++;

                                    team.value += updatedSortedData1[firstTeamsByConference[conference]].avg*2 + Windex*3;
                                    updatedSortedData1[firstTeamsByConference[conference]].value -= Windex / 2;
                                    updatedSortedData1[firstTeamsByConference[conference]].LossesTeams.push(team.team);
                                }
                                else {
                                    updatedSortedData1[firstTeamsByConference[conference]].wins++;
                                    updatedSortedData1[firstTeamsByConference[conference]].value += team.avg*2 + Windex*3;
                                    team.value -= Windex / 2;
                                    team.LossesTeams.push(updatedSortedData1[firstTeamsByConference[conference]].team);

                                }
                                num--;
                                secondTeamsByConference[conference] = team;
                            }
                        }
                        }
                });
                


                //console.log(updatedSortedData1);
                // Display the updated sorted data with win counts
                const updatedSortedData = Object.keys(updatedSortedData1).map(key => ({
                    team: key,
                    ...updatedSortedData1[key]
                    //})).sort((a, b) => (b.value - a.value)); // Sort in descending order again
                }))
                //.sort((a, b) => (b.value - a.value)); // Sort in descending order again
                .sort((a, b) => (b.value / (b.gp + 12) * 1 + 3 * b.avg / (b.gp*2)) - (a.value / (a.gp + 12) * 1 + 3*a.avg / (a.gp*2))); // Sort in descending order again
                
                //console.log(updatedSortedData);
                setTeams(updatedSortedData);
                gameScores.sort((a, b) => b.quality - a.quality);

                console.log(gameScores);
                setGames(gameScores);
            } catch (error) {
                console.error('Error fetching combined data:', error);
            }
            setLoading(false);
        };

        fetchData();

    }, [refresh]);

    const simulate = (r, ui) => {
        setRefresh(r);
        setUPSET_INDEX(ui);
    }



    
   // console.log(teams);
    return (
        <div className="more page">
            <div className="AppGameList leaderboard">
                <div className="Games">
                <div onClick={() => onPageChange("newGame")} className="Game B10"><div className="Gamelogo"><img src="b10_logo.png" /></div>
                        <div className="Gametitle">GIBBS B10</div>
                        <div className="Gamedescription">GIBBS, but for the Big Ten</div></div>
                    <div onClick={() => onPageChange("auctionGame")} className="Game QBX">
                        <div className="Gamelogo"><img src="qx.png" /></div>
                        <div className="Gametitle">QBX</div>
                        <div className="Gamedescription">Stock market game</div>
                    </div>
                   
                <div onClick={() => onPageChange("cfp")} className="Game CFP"><div className="Gamelogo"><img src="cfp.png" /></div>
                        <div className="Gameinfo">
                            
                                    <div className="Gametitle">CFP Projection</div>
                                    <div className="Gamedescription"><br/>Look at the latest College Football Playoff Projection created by GIBBS Analytics<br/><br/><i>Updated Every Week</i></div>
                            </div>
                        </div>
               

                    <div onClick={() => onPageChange("wrapped")} className="Game Wrapped">
                    <div className="Gameinfo">
                        <div className="Gametitle">GIBBS Wrapped</div>
                        <div className="Gamedescription"><br />Check out your picking preferences for the 2024/25 season!</div>
                    </div>
                </div>
                </div>
                {<><h1>NCAAF 2026 Simulation</h1>
                {games.map((game, index) => {
                    const awayIndex = teams.findIndex(t => t.team === game.away);
                      const homeIndex = teams.findIndex(t => t.team === game.home);

                      const awayRank = awayIndex !== -1 ? awayIndex + 1 : null;
                      const homeRank = homeIndex !== -1 ? homeIndex + 1 : null;

                    return (
                        <div key={game.id} style={{display: "flex", alignItems: "center", justifyContent: "center", gap:"5px", margin:"5px"}}>
                        <div className="game-team" style={{display: "flex", alignItems: "center", justifyContent: "end", fontSize:"10px", margin:"5px", width:"100px"}}>{game.ac}%<img
                                                key={index+game.id}
                                                src={getTeamLogoUrl(listOfTeams[game.away])}
                                                alt={game.away}
                                                style={{ width: 20, height: 20, marginLeft: 4 }}
                                            /></div> @ <div className="game-team" style={{display: "flex", alignItems: "center", justifyContent: "start", fontSize:"10px", margin:"5px", width:"100px", gap: '5px'}}><img
                                                key={index+game.id}
                                                src={getTeamLogoUrl(listOfTeams[game.home])}
                                                alt={game.home}
                                                style={{ width: 20, height: 20, marginLeft: 4 }}
                                            />{game.hc}%</div>
                        </div>
                    )
                    })}
                {!loading ? (
                    <div className="">
                        <table>
                            <thead>
                                <tr>
                                    <th>RK</th>
                                    <th>Team</th>
                                    <th style={{maxWidth: "100px"}}>Losses</th>
                                   {/*<th>avg</th>*/}
                                   <th>Line</th>
                                        
                                    <th>Record</th>
                                </tr>
                            </thead>
                            <tbody>
                                {teams.map((team, index) => {
                                    if(team.conference != "ACC!"){
                                        //return null;
                                    }
                                    return (
                                    team.team != "nationalAverages" && team.conference !== "Big Ten!" && <tr key={team.team}>
                                        <td>{index + 1}</td>
                                        <td><div className="table-team">{listOfTeams[team.team] && <img src={getTeamLogoUrl(listOfTeams[team.team])} alt={team.team} />}&nbsp;{team.team}</div></td>
                                        <td style={{maxWidth: "100px"}}>{team.LossesTeams.map((teamName, index) => (
                                            <img
                                                key={index}
                                                src={getTeamLogoUrl(listOfTeams[teamName])}
                                                alt={teamName}
                                                style={{ width: 20, height: 20, marginLeft: 4 }}
                                            />
                                        ))}</td>
                                        <td>{(team.avg * 1).toFixed(1)}</td>
                                        {/*<td>{(team.value).toFixed(0)}</td>
                                            <td>{((team.value / (team.gp + 12) * 1 + 3 * team.avg / (team.gp)) /3 - 1.5).toFixed(1)*10}</td>
                                        */}{/*<td>{team.conference}</td>*/}
                                        <td>{Math.round(team.wins*100, 2)/100} - {Math.round((team.gp - team.wins)*100, 2)/100}</td>
                                    </tr>
                                )})}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div>Refreshing...</div>
                )}
                </>}
            </div>
        </div>
    );
}


// UP: "&#11105;"
    // NEW: +
    // DOWN: &#11107;


const teams = [
    { seed: 1, name: 'Ohio State', trend: "", record: "(13-0)" },
    { seed: 2, name: 'Miami', trend: "", record: "(12-1)" },
    { seed: 3, name: 'Texas Tech', trend: "", record: "(12-1)" } ,
    { seed: 4, name: 'Alabama', trend: "", record: "(12-1)" } ,
    { seed: 5, name: 'Indiana', trend: "&#11105;", record: "(12-1)" } ,
    { seed: 6, name: 'Georgia', trend: "", record: "(10-2)" },
    { seed: 7, name: 'Oregon', trend: "&#11107;", record: "(12-1)" },
    { seed: 8, name: 'Utah', trend: "&#11105;", record: "(11-2)" },
    { seed: 9, name: 'Tennessee', trend: "", record: "(10-2)" } ,
    { seed: 10, name: 'Ole Miss', trend: "&#11107;", record: "(10-2)" } ,
    { seed: 11, name: 'Notre Dame', trend: "&#11107;", record: "(10-2)" } ,
    { seed: 12, name: 'Memphis', trend: "&#11107;", record: "(11-2)" } 
];

const teamsArray = ["Texas", "Oklahoma", "Vanderbilt", "USC", "Georgia Tech"];

const allTeams = [
    { seed: 1, name: 'Ohio State', record: "13-0*", criteria: "279" },
    { seed: 2, name: 'Georgia', record: "13-0*", criteria: "276" },
    { seed: 3, name: 'Oregon', record: "12-1", criteria: "269" },
    { seed: 4, name: 'Utah', record: "12-1*", criteria: "255" },
    { seed: 5, name: 'Tennessee', record: "11-1", criteria: "249" },
    { seed: 6, name: 'Ole Miss', record: "11-2", criteria: "248" },
    { seed: 7, name: 'Notre Dame', record: "11-1", criteria: "240" },
    { seed: 8, name: 'Miami', record: "11-1", criteria: "233" },
    { seed: 9, name: 'Texas', record: "10-2", criteria: "233" },
    { seed: 10, name: 'Penn State', record: "10-2", criteria: "225" },
    { seed: 11, name: 'Florida State', record: "11-2*", criteria: "225" },
    { seed: 12, name: 'TCU', record: "11-2", criteria: "222" },
    { seed: 13, name: 'Iowa State', record: "11-1", criteria: "222" },
    { seed: 14, name: 'Alabama', record: "10-2", criteria: "222" },
    { seed: 15, name: 'USC', record: "10-2", criteria: "212" },
    { seed: 16, name: 'Georgia Tech', record: "11-2", criteria: "208" },
    { seed: 17, name: 'BYU', record: "10-2", criteria: "204" },
    { seed: 18, name: 'Indiana', record: "10-2", criteria: "202" },
    { seed: 19, name: 'LSU', record: "9-3", criteria: "198" },
    { seed: 20, name: 'Texas Tech', record: "9-3", criteria: "191" },
    { seed: 21, name: 'Minnesota', record: "9-3", criteria: "186" },
    { seed: 22, name: 'Nebraska', record: "9-3", criteria: "194" },
    { seed: 23, name: 'Louisville', record: "9-3", criteria: "178" },
    { seed: 24, name: 'USF', record: "11-2", criteria: "180" },
    { seed: 25, name: 'Missouri', record: "8-4", criteria: "178" }
];

const getTeamLogoUrl = (id) => `https://a.espncdn.com/combiner/i?img=/i/teamlogos/ncaa/500/${id}.png&w=50&h=50`;

const rounds = [
  [1, 8, 9],
  [4, 5, 12],
  [2, 7, 10],
  [3, 6, 11]
];

const PlayoffProjection = () => {
  return (
      <div className="more page">
            <div className="AppGameList leaderboard">
              <div className="playoff-projection"><br />
                  <h5><i>Updated September 17th</i></h5>
      <div className="bracket">
        {rounds.map((round, roundIndex) => (
          <div className="round" key={roundIndex}>
            {round.map((seed, matchIndex) => {
              const team = teams.find(t => t.seed === seed);
              if (matchIndex === 0) {
                // If it's the first team in the round, it's a bye
                return (
                  <div className="matchup" key={matchIndex}>
                    <div className="bye">
                      <div className="team">
                        <div className="teamInfo">
                          <span className="seed">{team.seed}</span>
                          <img src={getTeamLogoUrl(listOfTeams[team.name])} alt={team.name} />&nbsp;{team.name} {/*team.record*/} <span dangerouslySetInnerHTML={{ __html: team.trend }} />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              } else if (matchIndex === 1) {
                // It's a regular matchup
                const nextTeamSeed = round[matchIndex + 1];
                const nextTeam = teams.find(t => t.seed === nextTeamSeed);

                return (
                  <div className="matchup" key={matchIndex}>
                    <div className="first">
                      <div className="team">
                        <div className="teamInfo">
                          <span className="seed">{team.seed}</span>
                          <img src={getTeamLogoUrl(listOfTeams[team.name])} alt={team.name} />&nbsp;{team.name} {/*team.record*/} <span dangerouslySetInnerHTML={{ __html: team.trend }} />
                        </div>
                      </div>
                      {nextTeam && (
                        <div className="team">
                          <div className="teamInfo">
                            <span className="seed">{nextTeam.seed}</span>
                            <img src={getTeamLogoUrl(listOfTeams[nextTeam.name])} alt={nextTeam.name} />&nbsp;{nextTeam.name} {/*nextTeam.record*/} <span dangerouslySetInnerHTML={{ __html: nextTeam.trend }} />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              }
            })}
          </div>
        ))}
      </div>
              </div>
              <BubbleTeams teams={teamsArray}/>
              {/*<h2 style={{ textAlign: "center" }}>Dropped out: <img src={getTeamLogoUrl(listOfTeams["Clemson"])} /> <img src={getTeamLogoUrl(listOfTeams["LSU"])} /> <img src={getTeamLogoUrl(listOfTeams["Kansas State"])} /> <img src={getTeamLogoUrl(listOfTeams["Boise State"])} /></h2>
  <h5 style={{textAlign: "center"}}>*Signifies Conference Champion</h5>*/}
    <br />

              <div>
                  <table>
                      <thead>
                          <tr>
                              <th>RK</th>
                              <th>Team</th>
                              <th>Record</th>
                              {/*<th>Points</th>*/}
                          </tr>
                      </thead>
                      <tbody>
                          {allTeams.map((team, index) => (
                              <tr key={index}>
                                  <td>{team.seed}</td>
                                  <td><div className="table-team"><img src={getTeamLogoUrl(listOfTeams[team.name])} alt={team.name} />&nbsp;{team.name}</div></td>
                                  <td>{team.record}</td>
                                  {/*<td>{team.criteria}</td>*/}
                              </tr>
                          ))}
                      </tbody>
                  </table>

              </div>
     </div>
      </div>
  );
};

const BubbleTeams = ({ teams }) => {
    return (
        <h2 style={{ textAlign: "center" }}>
            Bubble Teams:{" "}
            {teams.map((team) => (
                <div className="bubble"><img key={team} src={getTeamLogoUrl(listOfTeams[team])} alt={team} /></div>
            ))}
        </h2>
    );
};

export { More, PlayoffProjection };

const CACHE_KEY = "apiCache";

let cache = JSON.parse(localStorage.getItem(CACHE_KEY)) || {
  ratingsResponse: null,
  spResponse: null,
  talentResponse: null,
  gameResponse: null,
  lastUpdated: null
};

let useCache = true;

const saveCache = () => {
  localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
};

const fetchWithCache = async (key, url) => {
  if (useCache && cache[key]) {
    console.log(`✅ Using cached ${key}`);
    return cache[key];
  }

  console.log(`🌐 Fetching ${key} from ${url}`);
  const response = await fetch(url);
  const data = await response.json();

  cache[key] = data;
  cache.lastUpdated = Date.now();
  saveCache();

  return data;
};

const setUseCache = (val) => {
  useCache = val;
};
